// extracted by mini-css-extract-plugin
module.exports = {"task-form":"TaskForm_task-form__1hUhz","footer":"TaskForm_footer__8wksj","select":"TaskForm_select__2G0Xh","image-block":"TaskForm_image-block__1ViFT"};